// Feature switches for work that is built but not yet approved for the public site.
// Flip to true when the hotel gives the go-ahead (backend chat also needs AI_CHAT_ENABLED=true).
export const FEATURES = {
  aiChat: false,
  googleLogin: false,
  cmsAi: false,
};
